// extracted by mini-css-extract-plugin
export default {"minimum-spend-info":"minimum-spend-info--mp-l2SH5","minimumSpendInfo":"minimum-spend-info--mp-l2SH5"};